// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EmailUpdate-module-container-alL92{margin-top:44px}@media(min-width: 960px){.EmailUpdate-module-container-alL92{margin-block:80px 24px;margin-inline:170px 24px}}@media(min-width: 960px){.EmailUpdate-module-title-pp1bB{padding-inline-start:170px}}.EmailUpdate-module-loginButton-XN7H4{margin-top:10px;width:100%}@media(min-width: 960px){.EmailUpdate-module-loginButton-XN7H4{width:135px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "EmailUpdate-module-container-alL92",
	"title": "EmailUpdate-module-title-pp1bB",
	"loginButton": "EmailUpdate-module-loginButton-XN7H4"
};
export default ___CSS_LOADER_EXPORT___;
